@switch (image().type) {
  @case ('channel-logo') {
    @if (!channelImage().disabled) {
      @if (disableChannelLogoInteraction() || channelImage().disableLink || isOnlyMovieApp) {
        <ng-container *ngTemplateOutlet="mainLogoTem" />
      } @else {
        <a [routerLink]="['/']">
          <ng-container *ngTemplateOutlet="mainLogoTem" />
        </a>
      }
    }
    <ng-template #mainLogoTem>
      <img class="channel-logo" [src]="mainLogoUrl()" [alt]="mainLogoAlt" [ngStyle]="logoStyling()" />
    </ng-template>
  }

  @case ('movie-logo') {
    @if (movieLogo()) {
      <ng-container *ngTemplateOutlet="movieLogoTem" />
    }
    <ng-template #movieLogoTem>
      <img class="movie-logo" [src]="movieLogo()" [alt]="movieLogoAlt()" [ngStyle]="logoStyling()" />
    </ng-template>
  }

  @case ('custom') {
    @if (isCustomImageUrlExternal()) {
      <a [href]="customImage().url" target="_blank" rel="noopener noreferrer">
        <ng-container *ngTemplateOutlet="customImgTem; context: { $implicit: customImage() }" />
      </a>
    } @else if (customImage().url) {
      <a [routerLink]="customImage().url">
        <ng-container *ngTemplateOutlet="customImgTem; context: { $implicit: customImage() }" />
      </a>
    } @else {
      <ng-container *ngTemplateOutlet="customImgTem; context: { $implicit: customImage() }" />
    }

    <ng-template #customImgTem let-image>
      <img
        class="custom-image"
        [src]="image.src"
        [alt]="image.alt"
        [width]="image.width"
        [height]="image.height"
        [ngStyle]="logoStyling()"
      />
    </ng-template>
  }
}
